import { useId } from 'react'
import { IconProps } from './types'

export default function IconShare({
    width = '25',
    height = '26',
    stroke = '#0A2897',
    stopColor = '#C8E3F7',
    className,
}: IconProps) {
    const baseId = useId().replace(/:/g, '')
    const maskId = `${baseId}-share-mask`
    const gradientId = `${baseId}-share-gradient`

    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 25 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <mask
                id={maskId}
                maskUnits='userSpaceOnUse'
                x='0.625'
                y='-0.00390625'
                width='24'
                height='26'
                fill='black'
            >
                <rect
                    fill='white'
                    x='0.625'
                    y='-0.00390625'
                    width='24'
                    height='26'
                />
                <path d='M4.2168 19.0361C5.64805 19.0362 6.80837 20.1967 6.80859 21.6279C6.80859 23.0593 5.64819 24.2197 4.2168 24.2197C2.78538 24.2197 1.625 23.0593 1.625 21.6279C1.62523 20.1967 2.78552 19.0361 4.2168 19.0361ZM22.623 8.37109L16.2471 15.7549L15.3379 12.3301L17.2598 10.624C12.0087 11.0934 7.91595 14.316 5.6123 17.541C6.82813 10.8547 12.8854 7.19484 16.5352 6.62598L14.8389 5.5166L15.2393 1.99609L22.623 8.37109Z' />
            </mask>

            <path
                d='M4.2168 19.0361C5.64805 19.0362 6.80837 20.1967 6.80859 21.6279C6.80859 23.0593 5.64819 24.2197 4.2168 24.2197C2.78538 24.2197 1.625 23.0593 1.625 21.6279C1.62523 20.1967 2.78552 19.0361 4.2168 19.0361ZM22.623 8.37109L16.2471 15.7549L15.3379 12.3301L17.2598 10.624C12.0087 11.0934 7.91595 14.316 5.6123 17.541C6.82813 10.8547 12.8854 7.19484 16.5352 6.62598L14.8389 5.5166L15.2393 1.99609L22.623 8.37109Z'
                fill={`url(#${gradientId})`}
            />
            <path
                d='M4.2168 19.0361L4.21681 18.0361H4.2168V19.0361ZM6.80859 21.6279H7.80859V21.6278L6.80859 21.6279ZM4.2168 24.2197V25.2197H4.21681L4.2168 24.2197ZM1.625 21.6279L0.625 21.6278V21.6279H1.625ZM22.623 8.37109L23.3799 9.02466L24.0335 8.26773L23.2766 7.61417L22.623 8.37109ZM16.2471 15.7549L15.2805 16.0115L15.7664 17.8416L17.0039 16.4084L16.2471 15.7549ZM15.3379 12.3301L14.674 11.5822L14.2133 11.9912L14.3714 12.5867L15.3379 12.3301ZM17.2598 10.624L17.9236 11.3719L20.1924 9.35787L17.1707 9.628L17.2598 10.624ZM5.6123 17.541L4.62844 17.3621L6.42603 18.1223L5.6123 17.541ZM16.5352 6.62598L16.6892 7.61405L19.2602 7.21331L17.0825 5.78907L16.5352 6.62598ZM14.8389 5.5166L13.8453 5.4036L13.7756 6.0161L14.2915 6.35351L14.8389 5.5166ZM15.2393 1.99609L15.8928 1.23917L14.4596 0.00182855L14.2457 1.88309L15.2393 1.99609ZM4.2168 19.0361L4.21678 20.0361C5.09562 20.0361 5.80845 20.7489 5.80859 21.6281L6.80859 21.6279L7.80859 21.6278C7.80828 19.6445 6.20048 18.0362 4.21681 18.0361L4.2168 19.0361ZM6.80859 21.6279H5.80859C5.80859 22.507 5.09592 23.2197 4.21678 23.2197L4.2168 24.2197L4.21681 25.2197C6.20046 25.2197 7.80859 23.6116 7.80859 21.6279H6.80859ZM4.2168 24.2197V23.2197C3.33767 23.2197 2.625 22.5071 2.625 21.6279H1.625H0.625C0.625 23.6116 2.2331 25.2197 4.2168 25.2197V24.2197ZM1.625 21.6279L2.625 21.6281C2.62514 20.7489 3.33797 20.0361 4.2168 20.0361V19.0361V18.0361C2.23308 18.0361 0.625314 19.6445 0.625 21.6278L1.625 21.6279ZM22.623 8.37109L21.8662 7.71753L15.4902 15.1013L16.2471 15.7549L17.0039 16.4084L23.3799 9.02466L22.623 8.37109ZM16.2471 15.7549L17.2136 15.4983L16.3044 12.0735L15.3379 12.3301L14.3714 12.5867L15.2805 16.0115L16.2471 15.7549ZM15.3379 12.3301L16.0018 13.0779L17.9236 11.3719L17.2598 10.624L16.5959 9.87617L14.674 11.5822L15.3379 12.3301ZM17.2598 10.624L17.1707 9.628C11.557 10.1298 7.2245 13.5636 4.79858 16.9598L5.6123 17.541L6.42603 18.1223C8.6074 15.0684 12.4605 12.057 17.3488 11.6201L17.2598 10.624ZM5.6123 17.541L6.59617 17.7199C7.15546 14.6442 8.82879 12.2508 10.8123 10.5483C12.8101 8.83351 15.0684 7.86666 16.6892 7.61405L16.5352 6.62598L16.3812 5.63791C14.3522 5.95416 11.757 7.10167 9.5097 9.03065C7.24821 10.9718 5.28497 13.7515 4.62844 17.3621L5.6123 17.541ZM16.5352 6.62598L17.0825 5.78907L15.3862 4.67969L14.8389 5.5166L14.2915 6.35351L15.9878 7.46289L16.5352 6.62598ZM14.8389 5.5166L15.8325 5.6296L16.2329 2.1091L15.2393 1.99609L14.2457 1.88309L13.8453 5.4036L14.8389 5.5166ZM15.2393 1.99609L14.5857 2.75301L21.9695 9.12801L22.623 8.37109L23.2766 7.61417L15.8928 1.23917L15.2393 1.99609Z'
                fill={stroke}
                mask={`url(#${maskId})`}
            />

            <defs>
                <linearGradient
                    id={gradientId}
                    x1='12.1241'
                    y1='24.2197'
                    x2='12.1241'
                    y2='1.99609'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor={stopColor} />
                    <stop offset='1' stopColor='white' />
                </linearGradient>
            </defs>
        </svg>
    )
}
